export const removeEmptyStringFieldsRecursive = obj => {
    Object.keys(obj).forEach(key => {
      if (obj[key] === '') {
        delete obj[key];
      } else if (obj[key] && typeof obj[key] === 'object') {
        removeEmptyStringFieldsRecursive(obj[key]);
      }
    });
  };
  
  export default removeEmptyStringFieldsRecursive;
  